import React from "react";
import { Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const PageHeader = () => {
  const { t } = useTranslation();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        mb: 3,
        borderRadius: "16px",
        background: "linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)",
        color: "white",
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
        {t("Create Soil Test")}
      </Typography>
      <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
        {t(
          "Choose your preferred testing method and provide the required information"
        )}
      </Typography>
    </Paper>
  );
};

export default PageHeader;
